<template>
  <div class="menu-du-jour-panel">
    <div v-if="loading" class="mdj-loading">Chargement du menu…</div>

    <div v-else-if="items.length === 0" class="mdj-empty">
      <span class="mdj-empty-icon">📋</span>
      <p>Aucun menu importé pour ce jour.</p>
    </div>

    <div v-else class="mdj-grid">
      <div v-for="item in items" :key="item.category" class="mdj-card" :class="'mdj-cat-' + item.category">
        <span class="mdj-emoji">{{ categoryEmoji(item.category) }}</span>
        <div class="mdj-content">
          <span class="mdj-name">{{ item.name }}</span>
          <span class="mdj-cat-label">{{ item.categoryLabel }}</span>
          <span v-if="item.containsPork" class="mdj-pork-badge" title="Contient du porc">🐷</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const CATEGORY_EMOJI = {
  entree: "🥗",
  plat: "🍗",
  accompagnement: "🥦",
  produit_laitier: "🧀",
  dessert: "🍮",
  sans_viande: "🌿",
}

export default {
  name: "MenuDuJourPanel",

  props: {
    canteenId: { type: Number, default: null },
    date: { type: String, default: null },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  watch: {
    canteenId() {
      this.load()
    },
    date() {
      this.load()
    },
  },

  mounted() {
    this.load()
  },

  methods: {
    async load() {
      if (!this.canteenId || !this.date) return
      this.loading = true
      try {
        const resp = await fetch(`/api/v1/canteen/${this.canteenId}/menuItems/?date=${this.date}`, {
          credentials: "same-origin",
        })
        this.items = resp.ok ? await resp.json() : []
      } catch {
        this.items = []
      } finally {
        this.loading = false
      }
    },

    categoryEmoji(cat) {
      return CATEGORY_EMOJI[cat] || "🍽️"
    },
  },
}
</script>

<style scoped>
.menu-du-jour-panel {
  padding: 0.5rem 0;
}
.mdj-loading,
.mdj-empty {
  text-align: center;
  color: #888;
  padding: 1rem;
  font-size: 0.9rem;
}
.mdj-empty-icon {
  display: block;
  font-size: 2rem;
  margin-bottom: 0.25rem;
}
.mdj-grid {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.mdj-card {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.45rem 0.75rem;
  border-radius: 8px;
  background: #f8f9fa;
  border-left: 4px solid #dee2e6;
}
.mdj-cat-entree {
  border-left-color: #74c69d;
}
.mdj-cat-plat {
  border-left-color: #f4845f;
}
.mdj-cat-accompagnement {
  border-left-color: #4cc9f0;
}
.mdj-cat-produit_laitier {
  border-left-color: #ffd166;
}
.mdj-cat-dessert {
  border-left-color: #c77dff;
}
.mdj-cat-sans_viande {
  border-left-color: #95d5b2;
}

.mdj-emoji {
  font-size: 1.3rem;
  flex-shrink: 0;
}
.mdj-content {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.mdj-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: #212529;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mdj-cat-label {
  font-size: 0.7rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.mdj-pork-badge {
  font-size: 0.7rem;
  margin-top: 0.1rem;
}
</style>
